import { KeyboardEvent, useState } from 'react';

import type { BaseUIEvent } from '@base-ui/react/types';

export const useChipRemovalMark = (selectedValues: string[]) => {
  const selectionKey = selectedValues.join('\n');
  const [isLastChipMarked, setIsLastChipMarked] = useState(false);
  const [markedSelectionKey, setMarkedSelectionKey] = useState(selectionKey);
  if (selectionKey !== markedSelectionKey) {
    setMarkedSelectionKey(selectionKey);
    setIsLastChipMarked(false);
  }

  const handleKeyDown = (event: BaseUIEvent<KeyboardEvent<HTMLInputElement>>) => {
    const isBackspaceIntoChips =
      event.key === 'Backspace' && event.currentTarget.value === '' && selectedValues.length > 0;
    if (isBackspaceIntoChips && (!isLastChipMarked || event.repeat)) {
      event.preventBaseUIHandler();
      setIsLastChipMarked(true);
      return;
    }
    setIsLastChipMarked(false);
  };

  return { isLastChipMarked, handleKeyDown, clearMark: () => setIsLastChipMarked(false) };
};
